import * as _ from 'lodash'
import valueFilters from '../valueFilters';
import validator from '../validator';
import phoneNumberModel, { IPhoneNumber } from './phoneNumberModel';
import enums from '../enum';
import { IModelSet } from 'Scripts/modelSet';

export interface IPhonable {
	phoneNumbers: IModelSet<IPhoneNumber>;
	workPhoneNumber?: string;
	mobilePhoneNumber?: string;
	homePhoneNumber?: string;
	faxPhonenumber?: string;
	setPhoneNumber(type: number, number: string): void;
	getPhoneNumberByType(type: number): IPhoneNumber;
	getPhoneNumberByNumber(number: string): IPhoneNumber;
}

const phonable = {
	phoneNumbers: {
		defaultValue: [],
		setFilters: valueFilters.toModelSet(phoneNumberModel),
		rules: validator.validModel(phoneNumberModel.rules())
	},
	workPhoneNumber: {
		writable: false,
		nonSerialized: true
	},
	_get_workPhoneNumber: function () {
		const result = this.getPhoneNumberByType(enums.phoneNumberTypes.Work);

		return result ? result.number : '';
	},
	mobilePhoneNumber: {
		writable: false,
		nonSerialized: true
	},
	_get_mobilePhoneNumber: function () {
		const result = this.getPhoneNumberByType(enums.phoneNumberTypes.Mobile);

		return result ? result.number : '';
	},
	homePhoneNumber: {
		writable: false,
		nonSerialized: true
	},
	_get_homePhoneNumber: function () {
		const result = this.getPhoneNumberByType(enums.phoneNumberTypes.Home);

		return result ? result.number : '';
	},
	faxPhoneNumber: {
		writable: false,
		nonSerialized: true
	},
	_get_faxPhoneNumber: function () {
		const result = this.getPhoneNumberByType(enums.phoneNumberTypes.Fax);

		return result ? result.number : '';
	},
	setPhoneNumber: function (type, number) {
		if (!validator.isEnum(type, 'phoneNumberTypes', true)) { // || (number && !validator.isPhone(number))
			return;
		}

		const clear = phoneNumber => {
			if (!phoneNumber) {
				return;
			}

			const updatedType = enums.phoneNumberTypes.unset(type, phoneNumber.type);

			if (updatedType === 0) {
				this.phoneNumbers.delete(phoneNumber.key);
			}
			else {
				phoneNumber.type = updatedType;
			}
		};

		if (!number) {
			clear(this.getPhoneNumberByType(type));
		}
		else {
			// const formatted = util.phoneHelper.formatInternational(number);
			const existingByNumber = this.getPhoneNumberByNumber(number);
			const existingByType = this.getPhoneNumberByType(type);

			if (!existingByNumber && !existingByType) {
				// add a new number
				const model = phoneNumberModel({
					type: type,
					number: number
				});

				this.phoneNumbers[model.key] = model;
			}
			else if (existingByType && !existingByNumber) {
				if (existingByType.type === type) {
					// this phone is only used as this type - update it
					existingByType.number = number;
				}
				else {
					// this phone is currently used for multiple types - separate it into two phones
					clear(existingByType);
					const model = phoneNumberModel({
						type: type,
						number: number
					});

					this.phoneNumbers[model.key] = model;
				}
			}
			else if (existingByNumber && !existingByType) {
				// this is the same number and needs a new type added
				existingByNumber.type = enums.phoneNumberTypes.set(type, existingByNumber.type);
			}
			else if (existingByType && existingByNumber) {
				if (existingByType === existingByNumber) {
					// this is the same phone and needs a new type added
					existingByNumber.type = enums.phoneNumberTypes.set(type, existingByNumber.type);
				}
				else {
					// add the type to the phone by number, and clear the phone by type
					existingByNumber.type = enums.phoneNumberTypes.set(type, existingByNumber.type);
					clear(existingByType);
				}
			}
		}
	},
	getPhoneNumberByType: function (type) {
		return _.find(this.phoneNumbers, x => {
			return enums.phoneNumberTypes.isSet(type, x.type);
		});
	},
	getPhoneNumberByNumber: function (number) {
		return _.find(this.phoneNumbers, x => {
			return x.number === number;
		});
	}
};

export default phonable;